/* eslint-disable guard-for-in */
/* eslint-disable max-lines */
/* eslint-disable prefer-object-spread */
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Buffer } from 'buffer';
import { isMobile } from 'react-device-detect';
import { Box, Grid, IconButton, LinearProgress, Link, Typography } from '@mui/material';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { DocChecklistStyles as classes } from './DocChecklistStyles';
import Vector from '../../../images/Vector.svg';
import SuccessCheck from '../../../images/Document_Tick.png';
import { typeCorporationDbaPsc, typeDba, typeLlc, typeTrust } from './DocLabelTypes';
import {
  generateFileMD5,
  saveDocChecklistUploadLater,
  uploadDocChecklist,
  uploadDocumentByPreSignedURL,
  uploadDocXLDocCheckilst,
  uploadLaterDocument,
} from '../../../services/uploadService';
import KnockOffModal from '../../LeadGeneration/StepTwo/KnockOffModal';
import {
  CLICK_TO_UPLOAD,
  DOC_UPLOAD_LATER_HEADING,
  DOC_CHECKLIST_HEADING_MESSAGE,
} from '../../../constants';
import Layout from '../../Layout';
import ComercialImage3 from '../../../images/Comercial_Image_3.png';
import { commonTernary } from '../../commonCode';

const UploadLater = (props) => {
  const { history } = props;
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const [modalMessage, setModalMessage] = useState({
    message: '',
    messageTwo: '',
    messageKey: '',
    isKnockOff: false,
    hideClose: false,
    linkMsg: false,
    uploadMsg: '',
  });
  const [openModal, setOpenModal] = useState(false);
  const {
    setCurrentPage,
    progress,
    setProgress,
    docLabels,
    setDocLabels,
    uploadDocId,
    setUploadDocId,
    uploadStatus,
    setUploadStatus,
    uploadedFiles,
    setUploadedFiles,
    cancelDeed,
    cancelCorpRes,
    cancelCertIncorp,
    cancelArtIncorp,
    cancelListOff,
    cancelRegCer,
    cancelDbaRes,
    cancelLlcRes,
    cancelCertOrg,
    cancelOpAgree,
    cancelTrustReg,
    cancelIncumbency,
    checklistErr,
    setChecklistErr,
    urlAppId,
    accessToken,
    setLocation,
    setProductType,
    setProductName,
    setUserName,
    setApplicationId,
  } = leadGenerationContext;
  const wrapperRef = useRef(null);

  useEffect(() => {
    setCurrentPage('upload-documents-later');
    document.title = `Oriental - Document Upload`;
  }, []);

  const [docBusinessType, setDocBusinessType] = useState('');
  const [uploadResponse, setUploadResponse] = useState({});
  const [docLoading, setDocLoading] = useState(true);
  useEffect(() => {
    const initialCall = async () => {
      setDocLoading(true);
      const response = await uploadLaterDocument(urlAppId, accessToken);
      if (response && response.status === 200) {
        setDocLoading(false);
        if (response.data.caseStatus === 'Open') {
          if (response.data.docReUploadFlag === 'true') {
            const applicationTypeSplit = response.data.applicationType.split('|');
            setLocation(applicationTypeSplit[0]);
            setProductType(applicationTypeSplit[1]);
            setProductName(applicationTypeSplit[2]);
            setUserName(response.data.applicantDetails.custName.FrstName || 'Guest');
            setDocBusinessType(response?.data?.entityType);
            setUploadResponse(response.data);
            setApplicationId(response.data.applicationId);
          } else if (response.data.docReUploadFlag === 'false') {
            setModalMessage({
              ...modalMessage,
              messageKey: 'InviAllDetailsDone',
              messageTwo: `The link you are trying to access is not available as all the required details are submitted.`,
              isKnockOff: true,
              hideClose: true,
              linkMsg: true,
            });
            setOpenModal(true);
          }
        } else if (response.data.caseStatus === 'Closed') {
          setModalMessage({
            ...modalMessage,
            messageKey: 'InviCaseClosed',
            messageTwo:
              'The page you are trying to access is not available as the application is not open. Please contact our customer service at 787-620-7963.',
            isKnockOff: true,
            hideClose: true,
            linkMsg: true,
          });
          setOpenModal(true);
        }
      } else {
        setModalMessage({
          ...modalMessage,
          messageKey: 'InviInitialCallError',
          messageTwo: `We couldn't proceed further due to a technical issue. Please try again after some time.`,
          isKnockOff: true,
          hideClose: true,
          linkMsg: true,
        });
        setOpenModal(true);
      }
    };

    if (accessToken) {
      initialCall();
    }
  }, [accessToken]);
  useEffect(() => {
    if (docBusinessType) {
      switch (docBusinessType) {
        case 'DBA':
          setDocLabels(typeDba);
          break;
        case 'Corporation':
          setDocLabels(typeCorporationDbaPsc);
          break;
        case 'Corporation DBA':
          setDocLabels(typeCorporationDbaPsc);
          break;
        case 'LLC':
          setDocLabels(typeLlc);
          break;
        case 'Partnership':
          setDocLabels(typeCorporationDbaPsc);
          break;
        case 'Trust':
          setDocLabels(typeTrust);
          break;
        default:
          break;
      }
    }
  }, [docBusinessType, uploadResponse]);
  useEffect(() => {
    for (const item in uploadResponse.businessDocuments) {
      if (
        uploadResponse.businessDocuments[item].DocType &&
        uploadResponse.businessDocuments[item].PreSignedUrl
      ) {
        for (const label in docLabels) {
          if (docLabels[label].label === uploadResponse.businessDocuments[item].DocType) {
            setUploadedFiles((prevState) =>
              Object.assign({}, prevState, {
                [docLabels[label].name]: {
                  name: uploadResponse.businessDocuments[item].DocName,
                },
              })
            );
            setUploadStatus((prevState) =>
              Object.assign({}, prevState, {
                [docLabels[label].name]: 'success',
              })
            );
            setUploadDocId((prevState) =>
              Object.assign({}, prevState, {
                [docLabels[label].name]: uploadResponse.businessDocuments[item].DocId,
              })
            );
            break;
          }
        }
      }
    }
  }, [uploadResponse, docLabels]);

  const [isFileUploading, setIsFileUploading] = useState(false);

  const isChecklistValid = () => {
    let isStatusValid = true;
    for (const status in uploadStatus) {
      if (uploadStatus[status] === 'failed') {
        isStatusValid = false;
      }
    }
    return isStatusValid;
  };

  const setFocusForErrorFields = () => {
    for (const entityType in uploadStatus) {
      if (uploadStatus[entityType] === 'failed') {
        const element = document.getElementById(entityType);
        element?.removeAttribute('tabindex');
        if (element) {
          element.setAttribute('tabindex', '0');
          element.focus();
          // break;
        }
      }
    }
  };

  const checkAllDocsUploaded = () => {
    let flag = false;
    switch (docBusinessType) {
      case 'DBA':
        if (!uploadDocId.regCertificate || !uploadDocId.dbaResolution) {
          flag = true;
        }
        break;
      case 'Corporation':
      case 'Corporation DBA':
      case 'Partnership':
        if (
          !uploadDocId.regCertificate ||
          !uploadDocId.corpResolution ||
          !uploadDocId.articleIncorp ||
          !uploadDocId.certIncorp ||
          !uploadDocId.listOfOfficers
        ) {
          flag = true;
        }
        break;
      case 'LLC':
        if (
          !uploadDocId.LlcResolution ||
          !uploadDocId.certOfOrg ||
          !uploadDocId.opAgreement ||
          !uploadDocId.listOfOfficers ||
          !uploadDocId.regCertificate
        ) {
          flag = true;
        }
        break;
      case 'Trust':
        if (
          !uploadDocId.deedOfTrust ||
          !uploadDocId.certOfTrustReg ||
          !uploadDocId.certOfIncumbency ||
          !uploadDocId.regCertificate
        ) {
          flag = true;
        }
        break;
      default:
        break;
    }
    return flag;
  };
  const handleContinue = async () => {
    const valid = isChecklistValid();
    const reUploadFlag = checkAllDocsUploaded();
    if (valid) {
      setDocLoading(true);
      const resp = await saveDocChecklistUploadLater(
        uploadDocId,
        leadGenerationContext,
        docBusinessType,
        reUploadFlag
      );
      if (resp && resp.status === 201) {
        setDocLoading(false);
        history.push({
          pathname: `/${leadGenerationContext.language?.toLowerCase()}/commercial-form/thank-you`,
        });
      } else {
        setModalMessage({
          ...modalMessage,
          messageKey: 'InviInitialCallError',
          messageTwo: `We couldn't proceed further due to a technical issue. Please try again after some time.`,
          isKnockOff: true,
          hideClose: false,
          linkMsg: true,
        });
        setOpenModal(true);
      }
    } else {
      setDocLoading(false);
      setFocusForErrorFields();
    }
  };
  const onDrop = (e, fileType) => {
    e.preventDefault();
    const fileNameOnDrop = e.target.name;
    setUploadStatus((prevState) => Object.assign({}, prevState, { [fileNameOnDrop]: '' }));
    const file = e.dataTransfer.files[0];
    setUploadedFiles((prevState) => Object.assign({}, prevState, { [fileNameOnDrop]: file }));
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const onFileDrop = (e, fileType) => {
    e.preventDefault();
    setUploadStatus((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    const file = e.target.files[0];
    setUploadedFiles((prevState) => Object.assign({}, prevState, { [e.target.name]: file }));
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const handleWrapperRef = () => {
    if (wrapperRef?.current?.value) {
      wrapperRef.current.value = '';
    }
  };
  const uploadFile = async (file, e, fileType) => {
    setIsFileUploading(true);
    const fileName = file.name;
    const fileParts = fileName.split('.');
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase();
    const fileSize = file.size;
    const typeName = e.target.name;
    if (fileSize > 10485760) {
      handleWrapperRef();
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setIsFileUploading(false);
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'The file exceeds the maximum upload size (10 Mb).',
        })
      );
      return;
    }
    let isValidExtension = false;
    const extensions = ['pdf', 'jpg', 'jpeg', 'png'];
    if (extensions.includes(fileExtension.toLowerCase())) isValidExtension = true;
    if (!isValidExtension) {
      handleWrapperRef();
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Only files with the following formats are allowed: PNG, JPG, PDF.',
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    if (fileSize > 3145728) {
      const fileMD5 = await generateFileMD5(file);
      if (fileMD5) {
        await documentResponse(
          fileMD5,
          fileExtension,
          fileName,
          fileType,
          fileSize,
          file,
          typeName
        );
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: CLICK_TO_UPLOAD,
          })
        );
      }
    } else {
      const response = await uploadDocChecklist(
        fileExtension,
        fileName,
        fileType,
        formData,
        leadGenerationContext.accessToken,
        typeName,
        setProgress,
        leadGenerationContext
      );

      if (response?.data) {
        setUploadDocId((prevState) =>
          Object.assign({}, prevState, { [typeName]: response.data.documentId })
        );
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'success' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: '',
          })
        );
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: CLICK_TO_UPLOAD,
          })
        );
      }
    }
  };
  const documentResponse = async (
    fileMD5,
    fileExtension,
    fileName,
    fileType,
    fileSize,
    file,
    typeName
  ) => {
    const fileMd5Base64 = Buffer.from(fileMD5, 'hex').toString('base64');
    const response = await uploadDocXLDocCheckilst(
      fileExtension,
      fileName,
      fileType,
      fileSize,
      fileMd5Base64,
      leadGenerationContext.accessToken,
      typeName,
      setProgress,
      leadGenerationContext
    );

    if (response?.data) {
      const documentId = response.data.documentId ? response.data.documentId : null;
      const preSignedUrl = response.data.preSignedUrl ? response.data.preSignedUrl : null;
      if (preSignedUrl && documentId) {
        const resp = await uploadDocumentByPreSignedURL(
          preSignedUrl,
          file,
          fileMd5Base64,
          leadGenerationContext.setStatementUploadProgress,
          leadGenerationContext.setStatementLinearProgress
        );
        preSignedUrlResponse(resp, documentId, typeName);
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: 'Click to upload again.',
          })
        );
      }
    } else {
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Click to upload again.',
        })
      );
    }
  };
  const preSignedUrlResponse = (resp, documentId, _typeName) => {
    if (resp && resp.status === 200) {
      setUploadDocId((prevState) => Object.assign({}, prevState, { [_typeName]: documentId }));
      setUploadStatus((prevState) => Object.assign({}, prevState, { [_typeName]: 'success' }));
      setIsFileUploading(false);
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: '',
        })
      );
    } else {
      setIsFileUploading(false);
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: 'Click to upload again.',
        })
      );
      setUploadStatus((prevState) => Object.assign({}, prevState, { [_typeName]: 'failed' }));
    }
  };

  useEffect(() => {
    const types = [
      'corpResolution',
      'certIncorp',
      'articleIncorp',
      'listOfOfficers',
      'regCertificate',
      'dbaResolution',
      'LlcResolution',
      'certOfOrg',
      'opAgreement',
      'deedOfTrust',
      'certOfTrustReg',
      'certOfIncumbency',
    ];
    for (const type of types) {
      if (!uploadedFiles[type]) {
        setUploadDocId((prevState) => Object.assign({}, prevState, { [type]: '' }));
        setUploadStatus((prevState) => Object.assign({}, prevState, { [type]: '' }));
      }
    }
  }, [
    uploadDocId.corpResolution,
    uploadDocId.certIncorp,
    uploadDocId.articleIncorp,
    uploadDocId.listOfOfficers,
    uploadDocId.regCertificate,
    uploadDocId.dbaResolution,
    uploadDocId.LlcResolution,
    uploadDocId.certOfOrg,
    uploadDocId.opAgreement,
    uploadDocId.deedOfTrust,
    uploadDocId.certOfTrustReg,
    uploadDocId.certOfIncumbency,
    uploadStatus.corpResolution,
    uploadStatus.certIncorp,
    uploadStatus.articleIncorp,
    uploadStatus.listOfOfficers,
    uploadStatus.regCertificate,
    uploadStatus.dbaResolution,
    uploadStatus.LlcResolution,
    uploadStatus.certOfOrg,
    uploadStatus.opAgreement,
    uploadStatus.deedOfTrust,
    uploadStatus.certOfIncumbency,
    uploadStatus.certOfTrustReg,
  ]);
  const onKeyEnterCancel = (e) => {
    if (e.key === 'Enter') {
      handleCancel(e);
    }
  };

  const handleCancel = (e) => {
    if (e.target.name === 'deedOfTrust') {
      cancelDeed?.source?.cancel();
    }
    if (e.target.name === 'certIncorp') {
      cancelCertIncorp?.source?.cancel();
    }
    if (e.target.name === 'corpResolution') {
      cancelCorpRes?.source?.cancel();
    }
    if (e.target.name === 'articleIncorp') {
      cancelArtIncorp?.source?.cancel();
    }
    if (e.target.name === 'listOfOfficers') {
      cancelListOff?.source?.cancel();
    }
    if (e.target.name === 'regCertificate') {
      cancelRegCer?.source?.cancel();
    }
    if (e.target.name === 'dbaResolution') {
      cancelDbaRes?.source?.cancel();
    }
    if (e.target.name === 'LlcResolution') {
      cancelLlcRes?.source?.cancel();
    }
    if (e.target.name === 'opAgreement') {
      cancelOpAgree?.source?.cancel();
    }
    if (e.target.name === 'certOfOrg') {
      cancelCertOrg?.source?.cancel();
    }
    if (e.target.name === 'certOfTrustReg') {
      cancelTrustReg?.source?.cancel();
    }
    if (e.target.name === 'certOfIncumbency') {
      cancelIncumbency?.source?.cancel();
    }
    setUploadedFiles((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setUploadStatus((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setUploadDocId((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setProgress((prevState) => Object.assign({}, prevState, { [e.target.name]: 0 }));
  };
  const getFilePreview = (fileItem) => {
    let docType = '';
    for (const item in uploadResponse.businessDocuments) {
      if (
        uploadResponse.businessDocuments[item].DocType &&
        uploadResponse.businessDocuments[item].PreSignedUrl
      ) {
        for (const label in docLabels) {
          if (
            docLabels[label].name === fileItem.name &&
            docLabels[label].label === uploadResponse.businessDocuments[item].DocType
          ) {
            docType = uploadResponse.businessDocuments[item].PreSignedUrl;
            break;
          }
        }
      }
    }
    if (uploadedFiles[fileItem.name]?.type) {
      return URL.createObjectURL(uploadedFiles[fileItem.name]);
    }
    return docType;
  };

  return (
    <Layout
      ariaDescribedby="docChecklistHeading"
      headingId="docChecklistHeading"
      ariaDescribedbyId="DocChecklistDesc"
      classes={classes}
      descriptionKey={DOC_UPLOAD_LATER_HEADING}
      descriptionValue={DOC_UPLOAD_LATER_HEADING}
      // stepValue={1}
      handleBack={handleCancel}
      handleContinue={handleContinue}
      disableCondition={isFileUploading}
      backBtnTestid="back_button_testid"
      continueBtnTestid="continue_testId"
      screenLoading={docLoading}
      layoutImage={ComercialImage3}
    >
      <Box
        component="div"
        sx={classes.UploadContainer}
        role="main"
        aria-labelledby="docChecklistHeading"
      >
        <Box component="div" sx={classes.checklist_grid_margin_new}>
          {/* upload container */}
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Typography
                sx={classes.contact_heading}
                id="aboutYourBusiness"
                variant="h2"
                aria-label={t(DOC_CHECKLIST_HEADING_MESSAGE, {
                  defaultValue: DOC_CHECKLIST_HEADING_MESSAGE,
                  nsSeparator: '|',
                })}
              >
                {t(DOC_CHECKLIST_HEADING_MESSAGE, {
                  defaultValue: DOC_CHECKLIST_HEADING_MESSAGE,
                  nsSeparator: '|',
                })}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            // style={{ marginTop: '30px' }}
          >
            {docLabels.map((item) => (
              <Grid
                size={{ xs: 12, sm: 12, md: 6 }}
                sx={classes.gridItem}
                key={item.id}
                role="section"
              >
                <Box component="div" sx={classes.gridInnerDiv}>
                  <Box component="div" sx={classes.labelCheckContainer}>
                    <Typography sx={classes.businessType}>
                      {t(item.label, { defaultValue: item.label })}
                    </Typography>
                    {uploadStatus[item.name] === 'success' && (
                      <img
                        src={SuccessCheck}
                        height="16px"
                        alt="success icon"
                        name={item.name}
                        width="16px"
                      />
                    )}
                  </Box>
                  {/* main draggable container */}
                  {!uploadedFiles[item.name]?.name || uploadStatus[item.name] === 'failed' ? (
                    <>
                      <Box
                        component="div"
                        aria-roledescription={`Drag file here or Choose File ${item.label}`}
                        sx={[
                          classes.uploadContainer,
                          classes.box,
                          classes.box_a,
                          uploadStatus[item.name] === 'failed' && classes.error,
                          'drop-file-input',
                        ]}
                        id={item.name}
                      >
                        <Box component="span" sx={classes.dragDropText}>
                          <input
                            type="file"
                            name={item.name}
                            tabIndex="-1"
                            aria-label={` ${t(item.label)}`}
                            accept=".pdf,.jpg,.jpeg,.png"
                            style={classes.fileInput}
                            data-testid={`file_change_${item.label}`}
                            onChange={(e) => onFileDrop(e, item.label)}
                            ref={wrapperRef}
                            onDrop={(e) => onDrop(e, item.label)}
                          />
                          {!isMobile &&
                            t('Drag file here or', { defaultValue: 'Drag file here or' })}{' '}
                          <Box component="span" sx={classes.chooseFile}>
                            {t('Choose file', { defaultValue: 'Choose file' })}
                          </Box>
                        </Box>
                      </Box>
                      {uploadStatus[item.name] === 'failed' && (
                        <span
                          role="alert"
                          style={{
                            color: 'red',
                            display: 'block',
                            margin: '2px',
                            fontSize: '14px',
                          }}
                          data-testid="document-upload-error"
                        >
                          {t(checklistErr[item.name], {
                            defaultValue: checklistErr[item.name],
                            nsSeparator: '|',
                          })}
                        </span>
                      )}
                    </>
                  ) : (
                    <div>
                      <Box component="div" sx={classes.displayUploaded}>
                        {commonTernary(
                          uploadStatus[item.name] === '',
                          <Typography style={{ wordBreak: 'break-all', paddingRight: '5px' }}>
                            {uploadedFiles[item.name]?.name}
                          </Typography>,
                          <Link
                            style={{ paddingRight: '5px', wordBreak: 'break-all' }}
                            className={classes.uploadedFileName}
                            href={getFilePreview(item)}
                            target="_blank"
                          >
                            {uploadedFiles[item.name]?.name}
                          </Link>
                        )}
                        <Box component="span" sx={classes.cancelIcon}>
                          <IconButton
                            id="closeIconId"
                            name={item.name}
                            size="small"
                            onClick={handleCancel}
                            onKeyDown={onKeyEnterCancel}
                            data-testid={`cancel_testid_${item.name}`}
                            color="inherit"
                          >
                            <img
                              alt={t('cancel icon', { defaultValue: 'cancel icon' })}
                              name={item.name}
                              src={Vector}
                              height="12px"
                              width="12px"
                            />
                          </IconButton>
                        </Box>
                      </Box>

                      {commonTernary(
                        uploadStatus[item.name] === '',
                        <LinearProgress
                          value={progress[item.name]}
                          variant="determinate"
                          classes={{
                            barColorPrimary: classes.progressColor,
                            root: classes.linearBar,
                          }}
                        />,
                        ''
                      )}
                    </div>
                  )}
                  <div
                    style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Box component="div" sx={classes.file_size} style={{ paddingRight: '10px' }}>
                      {' '}
                      {t('Supported file types: PNG, JPG, PDF.', {
                        defaultValue: 'Supported file types: PNG, JPG, PDF.',
                        nsSeparator: '|',
                      })}
                    </Box>
                    <Box
                      component="div"
                      sx={classes.file_size}
                      style={{ paddingLeft: '10px', textAlign: 'right' }}
                    >
                      {' '}
                      {t('Max. 10MB', {
                        defaultValue: 'Max. 10MB',
                        nsSeparator: '|',
                      })}
                    </Box>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        {openModal && (
          <KnockOffModal message={modalMessage} setIsModal={setOpenModal} openModal={openModal} />
        )}
      </Box>
    </Layout>
  );
};

export default withRouter(UploadLater);
UploadLater.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
